export default __webpack_public_path__ + "static/media/ic_bolivia.e6814c67.svg";